module.exports = __webpack_public_path__ + "ai-botwpe6e82204f080956c07395725fe74a6a6.png";